/**
 * Tier parameters + budgets typed from contracts/tiers.json (the source of truth;
 * a unit test asserts this module's shape matches the contract file).
 */
import tiersJson from './contracts/tiers.json';
export const TIERS = tiersJson;
/** Per-tier engine parameters (prototype v3 values, SPEC-01 §2/§3). */
export const TIER_SETTINGS = {
    low: TIERS.tiers.low.params,
    mid: TIERS.tiers.mid.params,
    high: TIERS.tiers.high.params,
};
export const TIER_BUDGETS = {
    low: TIERS.tiers.low.budgets,
    mid: TIERS.tiers.mid.budgets,
    high: TIERS.tiers.high.budgets,
};
/** Render scale: 1 / maxScale is the lowest hardware scaling level (SPEC-01 §2). */
export function tierRenderScale(tier) {
    return 1 / TIERS.tiers[tier].params.maxScale;
}
